/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateAgentPolicyGrantForm,
  UpdateAgentPolicyGrantForm$Outbound,
  UpdateAgentPolicyGrantForm$outboundSchema,
} from "../components/updateagentpolicygrantform.js";

export type UpdateAgentPolicyGrantSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateAgentPolicyGrantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateAgentPolicyGrantForm: UpdateAgentPolicyGrantForm;
};

/** @internal */
export type UpdateAgentPolicyGrantSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateAgentPolicyGrantSecurity$outboundSchema: z.ZodMiniType<
  UpdateAgentPolicyGrantSecurity$Outbound,
  UpdateAgentPolicyGrantSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateAgentPolicyGrantSecurityToJSON(
  updateAgentPolicyGrantSecurity: UpdateAgentPolicyGrantSecurity,
): string {
  return JSON.stringify(
    UpdateAgentPolicyGrantSecurity$outboundSchema.parse(
      updateAgentPolicyGrantSecurity,
    ),
  );
}

/** @internal */
export type UpdateAgentPolicyGrantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateAgentPolicyGrantForm: UpdateAgentPolicyGrantForm$Outbound;
};

/** @internal */
export const UpdateAgentPolicyGrantRequest$outboundSchema: z.ZodMiniType<
  UpdateAgentPolicyGrantRequest$Outbound,
  UpdateAgentPolicyGrantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateAgentPolicyGrantForm: UpdateAgentPolicyGrantForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateAgentPolicyGrantForm: "UpdateAgentPolicyGrantForm",
    });
  }),
);

export function updateAgentPolicyGrantRequestToJSON(
  updateAgentPolicyGrantRequest: UpdateAgentPolicyGrantRequest,
): string {
  return JSON.stringify(
    UpdateAgentPolicyGrantRequest$outboundSchema.parse(
      updateAgentPolicyGrantRequest,
    ),
  );
}
